exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row[data-v-13dba8ea]{padding-top:10px;padding-bottom:10px}.row[data-v-13dba8ea]:hover{font-weight:700}.row .stato-ordine-1[data-v-13dba8ea]{color:var(--dark-green)}.row .stato-ordine-0[data-v-13dba8ea]{color:var(--dark-yellow)}.row .stato-ordine-2[data-v-13dba8ea]{color:var(--purple)}.row.pari[data-v-13dba8ea]{background-color:#f8f7f7}img[data-v-13dba8ea]{position:absolute;right:15px}.mob-inv[data-v-13dba8ea]{display:none}.mob-inv[data-v-13dba8ea]:hover{display:block}@media (min-width:768px){.mob-inv[data-v-13dba8ea]{display:block}.mobile[data-v-13dba8ea]{display:none}}", ""]);

// exports
